import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useI18n } from '../../../../../data/hooks/i18nHooks';
import Button from '../../../../elements/Button/Button';
import Modal from '../../../../elements/Modal';
import styles from './ManualInputModal.module.scss';

function ManualInputModal(props) {
    const { open, onClose, onAddCode } = props,
        i18n = useI18n(),
        [code, setCode] = useState(''),
        inputRef = useRef();

    useEffect(() => {
        if (open && inputRef.current) {
            inputRef.current.focus();
            setTimeout(() => {
                inputRef.current?.focus();
            }, 500);
        }
    }, [open]);

    const handleSubmit = useCallback(
        (e) => {
            e.preventDefault();
            e.stopPropagation();

            if (code) {
                onAddCode(code);
                setCode('');
            }
            onClose();
        },
        [code, onAddCode, onClose]
    );

    return (
        <Modal show={open} fullScreen={false} onClose={onClose} title={i18n['label.have-code']}>
            <form onSubmit={handleSubmit}>
                <input type="text" ref={inputRef} className={styles.input} value={code} onChange={(e) => setCode(e.target.value)} autoFocus />
                <div className={styles.buttonsWrapper}>
                    <Button className="outline" onClick={onClose}>
                        {i18n['label.cancel']}
                    </Button>
                    <Button className="primary" type="submit">
                        {i18n['label.ok']}
                    </Button>
                </div>
            </form>
        </Modal>
    );
}

export default ManualInputModal;
